import { useEffect, useState } from "react";
import { BookOpen, FileDown } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";

export default function Manual() {
  const [man, setMan] = useState(null);
  useEffect(() => { api.get("/manual").then((r) => setMan(r.data)); }, []);
  const pdf = () => window.open(`${process.env.REACT_APP_BACKEND_URL}/api/manual/pdf?auth=${localStorage.getItem("token")}`, "_blank");
  return (
    <div className="space-y-6" data-testid="manual-page">
      <PageHeader title="Manuel d'utilisation" subtitle="Guide pas à pas de toutes les fonctions, adapté à votre rôle">
        <Button className="bg-[#059669] hover:bg-[#047857]" onClick={pdf} data-testid="manual-pdf-btn"><FileDown size={16} /> Télécharger en PDF</Button>
      </PageHeader>
      {man && <div className="grid gap-6 lg:grid-cols-[220px_1fr]">
        <nav className="hidden space-y-1 self-start rounded-lg border bg-card p-3 text-sm lg:block" data-testid="manual-toc">
          {man.sections.map((s) => <a key={s.id} href={`#${s.id}`} className="block rounded px-2 py-1 hover:bg-muted">{s.title}</a>)}
        </nav>
        <div className="space-y-6">
          {man.sections.map((s) => (
            <section key={s.id} id={s.id} className="rise scroll-mt-6 rounded-lg border bg-card p-6" data-testid={`manual-section-${s.id}`}>
              <h3 className="font-display flex items-center gap-2 text-lg font-semibold"><BookOpen size={16} className="text-[#059669]" /> {s.title}</h3>
              <ul className="mt-3 list-disc space-y-1.5 pl-5 text-sm leading-relaxed">{s.items.map((it, i) => <li key={i}>{it}</li>)}</ul>
            </section>
          ))}
        </div>
      </div>}
    </div>
  );
}
